import { z } from '@bonanza-social/toolkit/api';

export const PromotedContentType = z.enum(['Subproviders', 'Games']);

export const PromotedContentItem = z.object({
  type: PromotedContentType,
  itemIds: z.array(z.number()),
});

export const PromotedContentSchema = z.array(PromotedContentItem);

export const PromotedContentResponseSchema = z.object({
  promotedContent: z.array(PromotedContentItem),
});
